<template>
	<span style="font-size: 10px">[1]</span>
</template>

<script>
export default {
	name: 'NumberSvg',
};
</script>
